/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Coinvestments_Declineallocation_Successmessage3Inputs */

const en_coinvestments_declineallocation_successmessage3 = /** @type {(inputs: Coinvestments_Declineallocation_Successmessage3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`You have declined this allocation. The GP has been notified.`)
};

/**
* | output |
* | --- |
* | "You have declined this allocation. The GP has been notified." |
*
* @param {Coinvestments_Declineallocation_Successmessage3Inputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const coinvestments_declineallocation_successmessage3 = /** @type {((inputs?: Coinvestments_Declineallocation_Successmessage3Inputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Coinvestments_Declineallocation_Successmessage3Inputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_coinvestments_declineallocation_successmessage3(inputs)
});
export { coinvestments_declineallocation_successmessage3 as "coInvestments_declineAllocation_successMessage" }